export default __webpack_public_path__ + "static/media/25-min.81487ea3.jpg";